import React from "react";
import {
  AmplitudeTech,
  AngularTech,
  ApolloTech,
  AssemblyTech,
  BashTech,
  BitbucketTech,
  ChargebeeTech,
  CircleCITech,
  ClickUpTech,
  CloudflareTech,
  CloudfrontTech,
  CloudwatchTech,
  CockroachDBTech,
  ConfigCatTech,
  ConfluenceTech,
  ConsulTech,
  CopilotTech,
  CouchDBTech,
  CSS3Tech,
  CTech,
  CypressTech,
  DatadogTech,
  DjangoTech,
  DockerTech,
  DovetailTech,
  DrawTech,
  EC2Tech,
  EclipseTech,
  ElasticTech,
  ExpressTech,
  ExtJSTech,
  FigmaTech,
  FirebaseTech,
  GATech,
  GatsbyTech,
  GCPTech,
  GithubActionsTech,
  GithubTech,
  GitlabTech,
  GitTech,
  GoTech,
  GQLTech,
  GrafanaTech,
  GruntTech,
  GulpTech,
  HandlebarsTech,
  HelmTech,
  HerokuTech,
  HTML5Tech,
  HubspotTech,
  InsomniaTech,
  IntercomTech,
  IonicTech,
  JavaTech,
  JenkinsTech,
  JestTech,
  JiraTech,
  JQueryTech,
  JQueryUITech,
  JSTech,
  K8STech,
  KafkaTech,
  KibanaTech,
  LambdaTech,
  LaunchDarklyTech,
  LeafletTech,
  LinuxTech,
  MailgunTech,
  MariaDBTech,
  MendixTech,
  MetabaseTech,
  MiroTech,
  MochaTech,
  MongoTech,
  MUITech,
  NestJSTech,
  NextJSTech,
  NginxTech,
  NodeJsTech,
  NotionTech,
  NPMTech,
  PandadocTech,
  PapertrailTech,
  PHPStormTech,
  PHPTech,
  PostgresTech,
  PostmanTech,
  PrimeReactTech,
  ProductboardTech,
  PrometheusTech,
  PythonTech,
  RancherTech,
  RDSTech,
  ReactTech,
  RedisTech,
  ReduxTech,
  RemixTech,
  S3Tech,
  SASSTech,
  SemanticUITech,
  SenchaTouchTech,
  SendGridTech,
  SentryTech,
  ServerlessTech,
  SketchTech,
  SlackTech,
  SnykTech,
  SQLServerTech,
  SQSTech,
  StorybookTech,
  StripeTech,
  StyledComponentsTech,
  SupabaseTech,
  TeamsTech,
  TerraformTech,
  TsTech,
  ValaTech,
  VercelTech,
  VimTech,
  VSCodeTech,
  VueTech,
  WebpackTech,
  WebstormTech,
  XRayTech,
  YarnTech,
} from "./techs";

export type JobEvent = {
  year: string;
  title: string;
  subtitle: string;
  company: string;
  project: React.JSX.Element;
  reason: React.JSX.Element;
  learnings: React.JSX.Element;
  salary: React.JSX.Element;
  clients: [];
  technologies: {
    imgSrc: string;
    label: string;
  }[];
  utilities: {
    imgSrc: string;
    label: string;
  }[];
  devOps: {
    imgSrc: string;
    label: string;
  }[];
  business: {
    imgSrc: string;
    label: string;
  }[];
};

export const events: JobEvent[] = [
  {
    year: "2007",
    title: "Diventando un informatico",
    subtitle: "Inizio dell'università e del percorso di studi da informatico",
    company: "",
    reason: (
      <>
        E' il 2007 e inizio finalmente la tanto agognata Università
        d'Informatica!
        <br />
        Negli ultimi anni delle superiori era diventato il mio sogno.
        Approfondire la materia che mi appassiona e capire come funziona il
        software in tutto e per tutto.
        <br />
        Scelgo Bologna come Alma Mater perché molti amici informatici, anche
        parecchio capaci, la frequentano e mi hanno raccontato aneddoti ed
        episodi che mi incuriosiscono profondamente.
        <br />
        Ad esempio, <b>il famoso corridoio di Informatica in via Zamboni</b>:
        puoi trovare persone che provano nuovi ambienti di sviluppo, altri che
        ricompilano kernel linux, altri ancora che aprono router per flasharci
        il firmware OpenWRT. Insomma, un laboratorio di nerd tra le aule!
        <br />
        <br />
        La prima accoglienza viene fatta da <b>Renzo Davoli</b>, il prof di
        Sistemi Operativi: il suo speech è incoraggiante e incredibilmente
        motivante. Non che ce ne sia bisogno per me ma è un'ulteriore conferma
        della buona scelta fatta.
        <br />
        <b>Vic</b>, il prof di Reti, ci racconta durante la prima lezione che la
        media per laurearsi è di 5 anni e mezzo, nonostante sia una triennale.
        Rientrerò esattamente in quella media. Probabilmente, la mole di esami e
        la loro difficoltà, rendono la triennale ardua da terminare in corso. Di
        fatti, solo uno del nostro corso, riuscirà a terminarla nei 3 anni.
        <br />
        <br />
        Durante gli anni universitari, faccio tantissimi progetti assieme ai
        miei colleghi, alcuni straordinariamente fighi!
        <br />
        Prima inizio con quello di <b>Architettura degli Elaboratori</b>, un
        progetto in Assembler 8088 chiamato{" "}
        <b>
          <a
            href="https://github.com/wilk/SVD88"
            target="_blank"
            rel="noreferrer"
          >
            SVD88
          </a>
        </b>{" "}
        (Sistema di elaborazione di segnali Video Digitali), con cui imparo a
        lavorare con i comandi assembly, i registri della CPU e il buffer.
        <br />
        Continuo quindi con quello super di <b>Reti di Calcolatori</b>,{" "}
        <b>
          <a
            href="https://github.com/wilk/VOWLAN"
            target="_blank"
            rel="noreferrer"
          >
            VOWLAN
          </a>
        </b>
        : si tratta di un sistema di comunicazione composto da una rete Wifi
        (simulata con una connessione TCP), una rete wired (simulata con una
        UDP) e un monitor il cui compito è quello di simulare la realtà, ossia
        perdendo, ritardando e cambiando l'ordine dei pacchetti trasmessi. Il
        progetto sarà scritto completamente in C e avrò modo di capire come
        creare e modificare pacchetti dati programmaticamente. Concluderò
        l'esame e il progetto con la lode assieme ai miei colleghi di progetto!
        <br />
        Tocca poi a <b>Sistemi Operativi</b>,{" "}
        <b>
          <a
            href="https://github.com/wilk/Kaya-2010"
            target="_blank"
            rel="noreferrer"
          >
            Kaya2010
          </a>
        </b>
        , un progetto diviso in due parti: strutture dati e algoritmica. Nella
        prima fase definiamo le strutture dei processi, i Process Control Block,
        mentre nella seconda costruiamo in tutto e per tutto un kernel, ossia un
        sistema operativo, con tanto di interrupt, system call e scheduler!
        Altra figata pazzesca!
        <br />
        Un altro progetto interessante è quello di{" "}
        <b>Linguaggi di Programmazione</b>,{" "}
        <b>
          <a
            href="https://github.com/wilk/IAS"
            target="_blank"
            rel="noreferrer"
          >
            IAS
          </a>
        </b>{" "}
        (Italian Air Strike), un gioco air strike scritto in Java dove
        l'obiettivo era quello di sparare a degli aeroplani con un cannone.
        Utilizzo la grafica di Metal Slug mentre la Baby, la mia super compagna
        di disavventure e progetti, realizza il motore fisico per il lancio del
        proiettile.
        <br />
        Infine,{" "}
        <b>
          <a
            href="https://github.com/wilk/SPAM"
            target="_blank"
            rel="noreferrer"
          >
            SPAM
          </a>
        </b>
        , per <b>Tecnologie Web</b>! Social Production of Audiovisual
        Microblogs, è una piattaforma federata di microblog. In questo corso, la
        nostra classe viene divisa in gruppi e ognuno deve sviluppare un'app
        composta da un backend e un frontend separati. Sono i primi anni di REST
        e delle SPA. Facciamo anche una fiera interna dove i team "acquistano" i
        backend e/o i frontend degli altri gruppi. La cosa figa è che è
        possibile cambiare la sorgente dei dati dall'interfaccia, preferendo un
        server piuttosto che un altro.
        <br />
        <br />
        La maggior parte dei progetti li faccio con la <b>Baby</b> che negli
        anni diventa la mia migliore amica. Stringo forti amicizie anche con
        altri colleghi di università.
      </>
    ),
    project: (
      <>
        I progetti sono vari ma coprono buona parte dell'informatica in lungo e
        in largo: reti, sistemi operativi, linguaggi di programmazione,
        architettura degli elaboratori e tecnologie web.
      </>
    ),
    learnings: (
      <>
        Imparo i concetti di base dell'informatica, diversi linguaggi di
        programmazione, strumenti e tecnologie. Imparo a rimanere nei tempi
        delle consegne, smussando gli angoli laddove è necessario.
      </>
    ),
    salary: (
      <>
        Gli unici introiti sono quelli derivanti da lezioni private di ECDL che
        do a studenti delle superiori e a un corso privato di ExtJS.
      </>
    ),
    clients: [],
    technologies: [
      JSTech,
      JQueryTech,
      JQueryUITech,
      ExtJSTech,
      JavaTech,
      AssemblyTech,
      CTech,
      BashTech,
      ValaTech,
    ],
    utilities: [VimTech, EclipseTech],
    devOps: [LinuxTech, GitTech, GithubTech],
    business: [],
  },
  {
    year: "2012",
    title: "L'inizio del lavoro",
    subtitle: "Fine dell'università e inizio nel mondo lavorativo",
    company: "Metislab",
    reason: (
      <>
        Appena laureato in Informatica a Bologna, inizio a lavorare come
        dipendente in una piccola software house locale, <b>Metislab</b>.<br />{" "}
        Voglio mettere in pratica quanto imparato e scoprire come funziona il
        lavoro nelle aziende tech. <br />
        Risulto come uno di quei <b>nerd super entusiasti</b> che ha voglia di
        mettersi alla prova e sperimentare un sacco!
        <br />
        Siamo in pochi e ognuno ha i suoi progetti da seguire. Avido di imparare
        e ampliare le mie conoscenze, mi butto a capofitto su tutto quel che c'è
        da fare, arrivando a fare giornate di 12 ore. L'idea di lavorare tanto
        mi piace e riesco a raccimolare qualche soldino in più con gli
        straordinari.
        <br />
        <br />
        Conosco <b>Axel</b>, uno sviluppatore con cui intesserò una profonda
        amicizia negli anni a venire.
        <br />
        Il lavoro mi porta ad avere <b>un contatto diretto coi clienti</b>, nel
        bene e nel male. Senza alcuna formazione al riguardo e appena fresco di
        università, questa sarà senz'altro l'attività più difficile da gestire.
        <br />
        <br />
        Tra i progetti che seguo, c'è ne uno in particolare che mi prende:{" "}
        <b>un preventivatore guidato</b> dove sostanzialmente l'utente si
        ritrova a configurare un prodotto e man mano il prezzo varia. Le
        tecnologie sono dell'epoca: PHP puro e JQuery.
      </>
    ),
    project: (
      <>
        Seguo alcuni progetti già in essere, sostanzialmente gestionali web
        realizzati ad hoc per diversi clienti della zona. Oltre allo sviluppo,
        mi occupo direttamente del supporto clienti per i progetti che seguo.
      </>
    ),
    learnings: (
      <>
        Imparo a lavorare su diversi progetti contemporaneamente, con nuove
        tecnologie e a relazionarmi coi clienti. Approfondisco le tecnologie web
        e imparo l'importanza del time management.
      </>
    ),
    salary: (
      <>
        Sono dipendente full-time, 40 ore a settimana, con uno stipendio mensile
        netto di 1.200€.
      </>
    ),
    clients: [],
    technologies: [
      JSTech,
      JQueryTech,
      JQueryUITech,
      HTML5Tech,
      PHPTech,
      SASSTech,
      AngularTech,
      SQLServerTech,
      ExtJSTech,
    ],
    utilities: [PHPStormTech],
    devOps: [],
    business: [],
  },
  {
    year: "2014",
    title: "Primo cambio",
    subtitle: "Da software house ad azienda di consulenza",
    company: "Ibuildings",
    reason: (
      <>
        In Metislab trovo resistenza nell'accogliere nuove tecnologie.{" "}
        <b>Angular</b> è appena stato rilasciato e sto tentando di portarlo in
        azienda ma invece di trovare entusiasmo, trovo scetticismo e diffidenza.{" "}
        <br /> Riesco a malapena a strappare mezz'ora di tempo al team per
        presentare le funzionalità della versione 4 di ExtJS, framework che ho
        imparato a padroneggiare all'università.
        <br />
        Seguo un <b>corso di tecnologie emergenti, Node.js e Ionic,</b> in quel
        di Brescia (dove entrerò in contatto con la mitica comunità{" "}
        <b>WebdeBS</b>) e parlando con diverse persone capisco che la mia
        attuale azienda non rispecchia le mie necessità. <br />
        <br />
        Perciò inizio a cercare lavoro e dopo circa un anno arriva un'offerta da
        una start-up di consulenza di Milano, <b>Ibuildings</b>, specializzata
        nello sviluppo di applicazioni web e mobile.
        <br />
        Inizialmente la rifiuto per il timore di fare un cambiamento troppo
        grosso ma dopo un paio di settimane li risento e accetto.
        <br />
        L'ambiente mi piace tantissimo: giovane, carico e desideroso di
        sperimentare le novità tecnologiche.{" "}
        <b>Esattamente quello che stavo cercando!</b> <br />
        Per di più, il lavoro è principalmente da remoto, se non con qualche
        occasionale giornata presso gli uffici dei clienti.
        <br /> Qui conosco nuovi colleghi, come{" "}
        <b>Eug, Beps, Giova, Barno, Alma, Andre, Boes, Ila, Robby</b> e tanti
        altri, con cui stringerò forti amicizie. <br />
        Faccio anche la mia <b>
          prima esperienza in qualità di Team Leader
        </b>{" "}
        che però si rivelerà essere un buco nell'acqua. Da una parte la mancanza
        di una formazione adeguata, dall'altra la mancanza di una giusta
        seniority nella gestione dei progetti.
        <br />
        <br />
        Trovo la consulenza molto interessante: tanti nuovi progetti ma senza
        doverci rimanere sopra per troppo tempo.
        <br />
        Per non parlare delle tecnologie: la possibilità di spaziare tra una e
        l'altra, mi permette di provarne sempre di nuove e capire come si sta
        trasformando lo sviluppo web.
        <br />
        <br />
        Tra i vari progetti, ho la possibilità di scrivere una SPA che{" "}
        <b>emulerà in tutto e per tutto Medium</b>, la piattaforma di blogging,
        scritto usando VueJS.
        <br />
        Un altro progetto interessante, scritto con Ionic, Angular e Cordova,
        sarà quello di un catalogo in formato app mobile che degli agenti usano
        per mostrare le ultime novità ai clienti e raccogliere potenziali
        ordini.
      </>
    ),
    project: (
      <>
        La consulenza mi spinge a realizzare tantissimi progetti diversi, sempre
        su tutto lo stack, applicazioni web e mobile ibride. Imparo a lavorare
        in team e stringo fortissimi legami con alcuni dei miei nuovi colleghi.
        <br />
        Tengo corsi privati e pubblici di tecnologie moderne, come Angular,
        Node.js, Ionic, Git, Sencha Builder e altri.
        <br />
      </>
    ),
    learnings: (
      <>
        Imparo a creare applicativi da zero, fare integrazioni con software
        esistenti, tenere corsi privati e pubblici, consigliare i team sulle
        possibili tecnologie da utilizzare per nuovi progetti, ascoltare i
        clienti raccogliendo specifiche e requisiti.
        <br />
        Affino le mie capacità nell'agile development e capisco quanto possa
        essere delicato gestire team e progetti.
      </>
    ),
    salary: (
      <>
        Continuo a essere dipendente a 40h settimanali ma con un{" "}
        <b>lavoro ibrido (remoto e on-site)</b>, con uno stipendio lordo annuo
        che arriva sui 30.000€.
      </>
    ),
    clients: [],
    technologies: [
      NodeJsTech,
      JSTech,
      ReactTech,
      MongoTech,
      TsTech,
      VueTech,
      GoTech,
      MUITech,
      IonicTech,
      AngularTech,
      CouchDBTech,
      ExtJSTech,
      SenchaTouchTech,
    ],
    utilities: [WebstormTech, VSCodeTech],
    devOps: [
      GithubTech,
      DockerTech,
      K8STech,
      JenkinsTech,
      WebpackTech,
      BitbucketTech,
      GulpTech,
      GruntTech,
    ],
    business: [SlackTech, JiraTech, ConfluenceTech],
  },
  {
    year: "2018",
    title: "Verso il prodotto",
    subtitle: "Dalla consulenza al prodotto",
    company: "Cloudfire",
    reason: (
      <>
        Dopo due anni dall'approdo in Ibuildings, la magia si spezza.
        <br />
        Alcuni dubbiosi episodi minano la fiducia del team, me compreso.
        <br />
        <b>Iniziano i primi turnover.</b>
        <br />
        Continuo a lavorare ma con distacco e con l'idea di fare un ulteriore
        passo nella mia crescita professionale.
        <br />
        Passano altri due anni, la voglia di fare consulenza è ormai passata,
        arriva la seconda figlia e la voglia di lavorare in un'azienda di
        prodotto mi spingono a un nuovo cambiamento.
        <br />
        <br />
        Mi contatta un ex compagno di classe delle medie, il <b>Bonda</b>, che
        nel frattempo ha avviato una start-up di prodotto, <b>Cloudfire</b>, in
        città con altri soci, nell'ambito <b>cloud e telecomunicazioni</b>.
        <br />
        La cosa mi intriga e capisco che hanno bisogno di qualcuno che tiri su
        il team di frontend e sviluppi l'interfaccia per la nuova piattaforma.
        <br />
        Così, studio per bene le piattaforme più conosciuto come GCP e AWS,{" "}
        <b>realizzando dei mock-up grafici con Sketch.</b>
        <br />
        Nell'arco di alcuni mesi riusciamo a sviluppare la prima versione
        funzionante di quello che sarà poi un prodotto di successo.
        <br />
        Qui, l'intervento di Alma, ex collega di Ibuildings giunta per aiutarci,
        sarà cruciale: con le sue capacità tecnica di UI e UX, dona un tocco
        grafico impareggiabile!
        <br />
        <br />
        Confrontando l'esperienza con la consulenza, mi rendo conto che lavorare
        su un singolo prodotto è molto più interessante ma che richiede uno
        sforzo sociale maggiore; il team deve essere ben coeso per riuscire a
        capire a come far evolvere il progetto.
        <br />
      </>
    ),
    project: (
      <>
        Il progetto riguarda una piattaforma per PMI italiane che permette di
        gestire il proprio IT in cloud. Gestisco il team di frontend e con loro
        realizziamo da zero l'applicativo con metodologia scrum.
      </>
    ),
    learnings: (
      <>
        Affino le mie capacità di gestione dei team e a sviluppare un prodotto
        da zero.
        <br /> Approfondisco le tematiche dell'infrastruttura cloud e imparo
        alcune nozioni nell'ambito telco.
      </>
    ),
    salary: (
      <>
        Ancora come dipendente, torno a lavorare in ufficio, full-time a 40h
        settimanale, con uno stipendio lordo annuo di 40.000€.
      </>
    ),
    clients: [],
    technologies: [
      JSTech,
      PythonTech,
      NodeJsTech,
      ReactTech,
      PostgresTech,
      HTML5Tech,
      TsTech,
      CSS3Tech,
      DjangoTech,
      GQLTech,
      KafkaTech,
      StyledComponentsTech,
      StorybookTech,
      CockroachDBTech,
      NPMTech,
      YarnTech,
      JestTech,
      CypressTech,
      SketchTech,
    ],
    utilities: [GATech, PostmanTech, ElasticTech, CopilotTech, VSCodeTech],
    devOps: [
      GCPTech,
      HelmTech,
      GitTech,
      GithubTech,
      DockerTech,
      GitlabTech,
      K8STech,
      WebpackTech,
      KibanaTech,
      GrafanaTech,
      ConsulTech,
      RancherTech,
      SnykTech,
      ConfigCatTech,
    ],
    business: [SlackTech, JiraTech, TeamsTech, ClickUpTech],
  },
  {
    year: "2019",
    title: "La cena è servita!",
    subtitle: "Dal cloud alla ristorazione",
    company: "Arreeba",
    reason: (
      <>
        Nonostante la bellissima esperienza di prodotto, faccio fatica ad
        allinearmi con la visione aziendale.
        <br />
        Nella mia mente comincia a prendere sempre più forma l'idea che il tempo
        speso in ufficio e al lavoro più in generale non debba essere statico e
        fisso a un ammontare di ore stabilito per un un'altra epoca, per un
        altro contesto.
        <br />
        <br />
        Mi pongo come nuovo obiettivo: quello di{" "}
        <b>ridurre l'orario lavorativo</b>.
        <br />
        <br />
        Nel frattempo, <b>Eug</b>, l'ex CTO di Ibuildings, mi propone una nuova
        collaborazione come <b>Software Architect in Ristoranti.it</b>,
        un'azienda tech che sviluppa app per ristoranti.
        <br />
        Così ritorno a lavorare in ibrido, con un giorno in ufficio e 4 da
        remoto, ma soprattutto porto l'orario di lavoro da 40 a 36 ore a
        settimana, che si traduce in un pomeriggio libero.
        <br />
        L'ambiente mi piace molto e lego tantissimo con i nuovi colleghi,
        soprattutto con <b>Gabry</b> con cui instaurerò un'amicizia forte e
        duratura.
        <br />
        <br />
        Il progetto mi prende tantissimo e l'idea di base è fighissima: una
        white label app customizzata per ogni ristorante ma con un'unica
        codebase e backend.
        <br />
        La pipeline di automazione per il rilascio delle app è impressionante.
        <br />É il periodo del boom del <b>serverless</b>, così spostiamo
        l'applicativo da istanze EC2 su Lambda, ma non tanto per moda quanto per
        la natura del settore. Pranzo e cena sono i due momenti clou in cui il
        traffico aumenta a dismisura ed è necessario scalare automaticamente. Il
        resto della giornata è invece molto più scarico. La notte è praticamente
        tutto fermo. Lambda risulta la scelta ideale.
        <br />
        <br />
        L'esperienza di prodotto in Ristoranti è diversa da quella di Cloudfire:
        il prodotto esiste già e deve essere evoluto, così come la customer
        base.
        <br />
        Qui le modifiche e le nuove funzionalità richiedono un attenzione
        maggiore siccome possono impattare clienti con un'attività già in essere
        e i loro clienti.
      </>
    ),
    project: (
      <>
        Ristoranti ha come prodotto una <b>white label app</b> che personalizza
        per ogni ristorante. Il mio ruolo è quello di ottimizzare l'architettura
        di backend.
      </>
    ),
    learnings: (
      <>
        Approfondisco il cloud di AWS, le nuove tecnologie serverless e imparo
        le peculiarità del settore della ristorazione.
      </>
    ),
    salary: (
      <>
        Sempre come dipendente ma torno ibrido, 4 giorni da remoto e uno in
        ufficio. Lo stipendio rimane di 40K lordi l'anno ma{" "}
        <b>l'orario passa da 40 a 36 ore a settimana</b>, che si traduce in un
        pomeriggio libero.
      </>
    ),
    clients: [],
    technologies: [
      JSTech,
      NodeJsTech,
      ReactTech,
      HTML5Tech,
      PostgresTech,
      TsTech,
      RedisTech,
      S3Tech,
      FirebaseTech,
      GQLTech,
      ApolloTech,
      ServerlessTech,
      SemanticUITech,
    ],
    utilities: [GATech, VSCodeTech],
    devOps: [
      CloudflareTech,
      EC2Tech,
      LambdaTech,
      CloudfrontTech,
      GitTech,
      GithubTech,
      DockerTech,
      SentryTech,
      CloudwatchTech,
      JestTech,
      DatadogTech,
      MochaTech,
      XRayTech,
    ],
    business: [StripeTech, SlackTech, JiraTech, ConfluenceTech],
  },
  {
    year: "2020",
    title: "Dall'Italia alla Danimarca",
    subtitle: "Dai ristoranti alla logistica",
    company: "Portchain",
    reason: (
      <>
        Purtroppo il futuro di Ristoranti.it è segnato. Non c'è voglia da parte
        della proprietà di investire nel progetto e così le persone cominciano
        ad andarsene.
        <br />
        Gioco d'anticipo e rispolvero un vecchio sogno nel cassetto:{" "}
        <b>lavorare da remoto per l'estero!</b>
        <br />
        Il 2020 è cominciato da poco: esplode la pandemia di Covid,
        Ristoranti.it fallisce e io decido di aumentare l'entropia facendo un
        centinaio di apply per aziende estere.
        <br />
        <br />
        Dopo diversi colloqui, entro in <b>Portchain</b>, azienda tech nel campo
        logistico marittimo.
        <br />
        Qui lego moltissimo col team di bresciani e inizia la mia prima
        esperienza con un team internazionale.
        <br />
        Ho il privilegio di conoscere squisite persone come{" "}
        <b>Dan, Helena, Mehmet e Utku</b>.
        <br />
        Lavoro su un prototipo con un team formato da poco e inizio a
        interessarmi del settore dei carrier e dei terminal marittimi. Nomi come
        Maersk, ONE e Hapag Lloyd ora iniziano ad avere un senso.
        <br />
        Il progetto permette ai grandi player del mercato di sincronizzarsi,
        raccogliendo dati pubblici con diversi scraper, incrociandoli e fornendo
        un'applicazione web per la consultazione e la modifica.
        <br />
        Grazie ai nuovi colleghi, approfondisco la programmazione funzionale.
        <br />
        <br />
        Se inizialmente faccio fatica ad esprimermi con la lingua, riempiendo le
        call di gaffe e momenti imbarazzanti, dopo qualche mese riesco a
        padroneggiarla e ad argomentare meglio i miei pensieri. Le figure di
        merda calano.
      </>
    ),
    project: (
      <>
        Il progetto riguarda un prototipo pensato per facilitare la
        comunicazione e l'organizzazione tra i vari attori della catena
        logistica marittima: carrier e terminali.
      </>
    ),
    learnings: (
      <>
        Ho avuto modo di perfezionare il mio inglese, confrontandomi con un team
        internazionale. Imparo il linguaggio funzionale e nuove piattaforme di
        logging e cloud.
      </>
    ),
    salary: (
      <>
        <b>Apro partita IVA</b> e il mio stipendio raggiunge i 65K lordi annui.
        Passo da lavoro ibrido a <b>full-remote</b>,{" "}
        <b>da 36 a 35 ore a settimana</b> (5 giorni da 7 ore).
      </>
    ),
    clients: [],
    technologies: [
      JSTech,
      NodeJsTech,
      TsTech,
      ReactTech,
      HTML5Tech,
      PostgresTech,
      S3Tech,
      GQLTech,
      ReduxTech,
      HerokuTech,
      KafkaTech,
      NextJSTech,
      ApolloTech,
      StyledComponentsTech,
    ],
    utilities: [MailgunTech, AmplitudeTech, MetabaseTech, VSCodeTech],
    devOps: [
      GitTech,
      GithubTech,
      GithubActionsTech,
      DockerTech,
      SentryTech,
      CircleCITech,
      DatadogTech,
      PapertrailTech,
    ],
    business: [SlackTech, JiraTech, ConfluenceTech, DovetailTech],
  },
  {
    year: "2021",
    title: "This is UK, Sir!",
    subtitle: "Dalla logistica alla sanità",
    company: "Birdie",
    reason: (
      <>
        Il prototipo in fase di sviluppo fatica ad avere un riscontro con la
        realtà. A poco a poco, anche il team perde fiducia e comincia ad
        andarsene.
        <br />
        Anche io inizio a dubitare che il mio contributo sia effettivo, così
        seguo Dan che nel frattempo ha trovato posto in un'azienda UK.
        <br />
        <br />
        Dopo una serie di colloqui con <b>Birdie</b>, la collaborazione parte.
        <br />
        Il primo touchpoint è con uno dei fondatori, <b>Gwen</b>, a Bologna,
        davanti a un ottimo spritz, in compagnia di Axel.
        <br />
        L'azienda è una scale-up che sta chiudendo un cospicuo round di
        finanziamenti e opera nel settore sanitario privato, fornendo una
        piattaforma per l'assistenza domiciliare a diverse agenzie sparse sul
        territorio d'oltre Manica.
        <br />
        Birdie ha una forte cultura di engineering e ha adottato in parte{" "}
        <b>il modello Spotify</b>, con squad, tribe, chapter e guild.
        <br />
        La comunicazione è alta e tutto è fortemente documentato, siccome il
        grosso dell'azienda è in remoto.
        <br />
        Sono in mezzo a persone altamente qualificate e tremendamente capaci:
        diverse volte mi rendo conto di essere quello più ignorante nella
        stanza. Il che è un bene ma richiede uno sforzo notevole.
        <br />
        <br />
        Conosco tantissime nuove persone eccezionali, quali{" "}
        <b>Shabeer, Eben, Tom, Ryan, Ravi, Einar, Leo, Sam.</b>
        <br />
        In Birdie, lavoro in diverse aree del prodotto, tra cui le integrazioni
        con i partner e gli strumenti per il customer support.
        <br />
        Il monitoraggio di tali integrazioni risulta essere tanto importante
        quanto le integrazioni stesse. Infatti, la frequenza, il formato e la
        validità dei dati cambia da integrazione a integrazione.
        <br />
        La gestione dei dati che entrano nel sistema è estremamente importante
        per le agenzie che integrano i loro sistemi con quelli di Birdie.
        <br />
        <br />
        Ho anche la possibilità di lavorare con una piattaforma low-code,{" "}
        <b>Retool</b>, per un prototipo pensato per la funzionalità self-serve
        della piattaforma.
      </>
    ),
    project: (
      <>
        In Birdie mi occupo delle integrazioni con i partner (Rostering
        Integrations) e di migliorare gli strumenti utilizzati dal team di
        customer support.
      </>
    ),
    learnings: (
      <>
        Comprendo in modo approfondito l'analisi e il monitoraggio dei sistemi,
        come rendere efficaci le integrazioni software e come diversi team di
        engineering si coordinano tra di loro.
      </>
    ),
    salary: (
      <>
        Sempre in full-remote, a 35 ore a settimana, il mio stipendio sale fino
        a 83K lordi l'anno.
      </>
    ),
    clients: [],
    technologies: [
      JSTech,
      NodeJsTech,
      ReactTech,
      TsTech,
      PostgresTech,
      HTML5Tech,
      RedisTech,
      S3Tech,
      ExpressTech,
      ReduxTech,
      RDSTech,
      HandlebarsTech,
      NextJSTech,
      NestJSTech,
      StyledComponentsTech,
    ],
    utilities: [VSCodeTech],
    devOps: [
      SQSTech,
      GitTech,
      GithubTech,
      GithubActionsTech,
      DockerTech,
      NPMTech,
      K8STech,
      TerraformTech,
      GrafanaTech,
      SentryTech,
      CloudwatchTech,
      JestTech,
      DatadogTech,
    ],
    business: [
      ChargebeeTech,
      SlackTech,
      JiraTech,
      HubspotTech,
      IntercomTech,
      NotionTech,
      ProductboardTech,
      PandadocTech,
    ],
  },
  {
    year: "2022",
    title: "Libero professionista",
    subtitle: "Dalla Gran Bretagna al rientro in Italia come consulente",
    company: "Autonomo",
    reason: (
      <>
        Nonostante Birdie sia l'azienda che più si avvicini alle moderne living
        organizations, <b>finisco in burnout</b>.
        <br />
        La frenetica corsa all'espansione e la conquista del mercato enterprise,
        snaturano l'azienda.
        <br />
        Subentrano performance review e mi ritrovo soggetto di quello che nel
        gergo è definito come "<i>gaslighting</i>".
        <br />
        A Dicembre 2022 arrivo al culmine del burnout e decido di lasciare.
        <br />
        <br />
        Dopo un paio di mesi di recupero, penso sia giunta l'ora di
        intraprendere una nuova strada: diventare <b>consulente</b>.<br /> La
        scelta è dettata da diverse motivazioni. Una è sicuramente quella di non
        essere vincolato ai dettami di un'azienda e delle politiche interne che
        troppo spesso sono fatte per sopperire alla mancanza di fiducia e di
        adeguati processi. Un'altra è quella di tornare a lavorare localmente,
        nella mia città, per contribuire con il mio know-how acquisito nel
        tempo.
        <br />
        Anche l'idea di conoscere tante nuove realtà contribuisce a questo
        cambiamento.
        <br />
        <br />
        E' durante questi ultimi anni che <b>rivedo le mie convinzioni</b>{" "}
        costruite nel tempo, una su tutte quella di non bazzicare mai i porti
        già visitati, ossia le vecchie aziende.
        <br />
        Mi ricredo quando intraprendo un paio di collaborazioni con precedenti
        aziende, quali Cloudfire e Portchain. Tornare in ambienti di lavoro già
        vissuti è strano ma decisamente interessante.
        <br /> Talvolta il ruolo cambia grazie alle esperienze fatte in altre
        aziende.
        <br />
        In qualità di consulente, il lavoro si mischia tra operativo e
        manageriale. Capisco che spesso{" "}
        <b>la causa principe di molti problemi</b> che i team affrontano
        quotidianamente è annidata nella struttura gerarchica aziendale. Le
        decisioni top-down spezzano la fiducia tra chi gestisce e chi opera,
        portando i primi a enormi delusioni e incomprensioni mentre frustrazione
        e disingaggio ai secondi.
        <br />
        Il <b>self-management</b> diventa un'alternativa valida ma non adatta a
        tutti: infatti, su entrambi i fronti, trovo riluttanza e resistenza,
        talvolta paradossale. Manager che vogliono continuare a impartire ordini
        agendo da dittatori benevoli ignorando le esigenze personali del team;
        dipendenti che vogliono essere scevri di qualsiasi responsabilità ma
        dotati di totale autonomia.
        <br />
        <br />
        Grazie al passaparola, al networking e anche all'azione gratuita,
        partono nuovi progetti, iniziano nuove collaborazioni e stringo nuove
        amicizie.
        <br />
        Il compenso è variabile, nonostante abbia definito un mio listino. A
        volte mi ritrovo a fare consulenze gratuite perché interessato al
        progetto o semplicemente per dare una mano e farmi conoscere. Altre
        volte, trovo una via di mezzo quando si tratta di fare upskilling su
        nuove tecnologie.
        <br />
        Imparo che è <b>più importante la relazione con le persone</b> invece
        dell'essere fisso e irremovibile sulla paga.
        <br />
        <br />
        In qualità di consulente, la <b>variabilità</b> è una dei punti più
        forti e gratificanti. Che sia la gestione del proprio tempo, la scelta
        dei progetti, il compenso, il coinvolgimento.
        <br />
        L'altra faccia della medaglia però comporta un'alta incertezza, un
        ragionamento spannometrico sull'anno invece che sul mese, periodi di
        magra dove è difficile trovare progetti e periodi intensi dove è
        necessario fare scelte che ne escluderanno altre.
      </>
    ),
    project: (
      <>
        La consulenza mi porta a sviluppare prototipi e applicativi web,
        analizzare scelte infrastrutturali e architetturali, fare formazione e
        coaching, strutturare i team e i processi aziendali.
      </>
    ),
    learnings: (
      <>
        Approfondisco le mie capacità in termini di leadership e di conoscenza
        architetturale, scopro e conosco nuovi strumenti, imparo ad usare nuove
        piattaforme.
      </>
    ),
    salary: (
      <>
        Il tempo è estremamente variabile. Non vivo più il concetto di full-time
        o part-time ma di progetto. Il compenso è giornaliero e varia da 300 a
        400€, dipendentemente dalla commessa. Stare a casa o andare in ufficio è
        una scelta che prendo dipendentemente dalla situazione.
      </>
    ),
    clients: [],
    technologies: [
      NodeJsTech,
      TsTech,
      ReactTech,
      NginxTech,
      PostgresTech,
      SASSTech,
      MariaDBTech,
      RemixTech,
      MendixTech,
      PrimeReactTech,
      GatsbyTech,
      LeafletTech,
    ],
    utilities: [
      InsomniaTech,
      CopilotTech,
      VSCodeTech,
      FigmaTech,
      MiroTech,
      DrawTech,
    ],
    devOps: [
      SupabaseTech,
      ElasticTech,
      SendGridTech,
      VercelTech,
      GitTech,
      GithubTech,
      GithubActionsTech,
      KibanaTech,
      GrafanaTech,
      SentryTech,
      PrometheusTech,
      LaunchDarklyTech,
      ConfigCatTech,
    ],
    business: [SlackTech, TeamsTech],
  },
];
